import { Typography, Tooltip } from "@mui/material";
import { Icon } from "pepsico-ds";

const styles = {
  sectionTitle: {
    color: "var(--Tokens-Text-Primary, #3A3A3A)",
    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "22px",
    fontFeatureSettings: "'liga' off, 'clig' off",
  },
  itemText: {
    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
    color: "text.primary",
    fontSize: ".9rem",
    fontStyle: "normal",
    fontWeight: 600,
  },
};

const Chapter = ({ highlights }) => {
  if (
    (!highlights?.chapters || highlights.chapters.length === 0) &&
    (!highlights?.subtitles || highlights.subtitles.length === 0)
  ) {
    return null; // Hide entire block completely
  }

  return (
    <div
      className="flex flex-col gap-3 flex-wrap"
      data-testid="chapter-container"
    >
      {/* Chapters Section */}
      <div
        data-testid="chapter-list"
        style={{ display: `${!highlights?.chapters?.length ? "none" : ""}` }}
      >
        <Typography
          variant="body1"
          sx={{
            ...styles.sectionTitle,
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            alignItems: "center",
          }}
        >
          <span>Chapters</span>
          <Tooltip title="Chapter titles that contain the search term" arrow>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Icon
                alt="Chapter titles that contain the search term"
                icon="info"
                size="small"
                className="$color-icon-default"
              />
            </span>
          </Tooltip>
        </Typography>

        <div className="flex flex-wrap">
          {highlights?.chapters?.map((chapter, index) => (
            <Typography
              key={index}
              data-testid={`chapter-item-${index}`}
              sx={styles.itemText}
              dangerouslySetInnerHTML={{ __html: chapter }}
            />
          ))}
        </div>
      </div>

      {/* Subtitles Section */}
      <div
        data-testid="subtitle-list"
        style={{ display: `${!highlights?.subtitles?.length ? "none" : ""}` }}
      >
        <Typography
          variant="body1"
          sx={{
            ...styles.sectionTitle,
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            alignItems: "center",
          }}
        >
          Subtitles
          <Tooltip title="Spoken content that contains the search term" arrow>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Icon
                alt="Spoken content that contains the search term"
                icon="info"
                size="small"
                className="$color-icon-default"
              />
            </span>
          </Tooltip>
        </Typography>

        {highlights?.subtitles?.map((subtitle, index) => (
          <Typography
            key={index}
            data-testid={`subtitle-item-${index}`}
            sx={styles.itemText}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        ))}
      </div>
    </div>
  );
};

export default Chapter;
